import logo from "../assets/img/logo/HD_wit_transparant_cropped.png";

export default function Landing({ title }) {
  return (
    <header id="landing">
      <div className="landing">
        <div className="landing__content">
          <div className="landing__title">{title}</div>
          <img className="landing__logo__image" src={logo} alt="demo"></img>
          <div className="landing__title__mobile">{title}</div>
        </div>
      </div>
    </header>
  );
}
